import React, { Component, useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { DashboardAcompProducaoDashJustificativa } from "../../../components/classes/DashAcompProducao";
import { DashOtif } from "../../../components/classes/DashOtif";

export default function ChartProd03(props: ChartProd01Props){
  const [seriesMixedChart, setSeriesMixedChart] = useState<{name: string, type: string, data: number[], color: string}[]>([]);
  const [optionsMixedChart, setOptionsMixedChart] = useState<ApexCharts.ApexOptions>({
    dataLabels: {
      enabled: true,
      style:{
        fontSize: "13",
        fontFamily: "Roboto",
        colors: ['white']
      },
      background: {
        enabled: true,
        foreColor: 'black',
        padding: 4,
        borderRadius: 1,
        borderWidth: 1,
        borderColor: 'black',
        opacity: 0.9,
        dropShadow: {
          enabled: false,
          top: 1,
          left: 1,
          blur: 1,
          color: '#000',
          opacity: 0.45
        }
      },
    },
    plotOptions:{
      bar:{
        dataLabels:{
          orientation: "vertical",
          hideOverflowingLabels: true
        }
      }
    }
  });

  useEffect(()=>{

    setSeriesMixedChart(
      props.data?.justificativas?.map(x=> {
        return {
          name: x.name,
          color: x.positivo ? '#1AA14A' : '#F76767', 
          data: x.data,
          type: "column"
        };
      }) ?? []
    )
    
    setOptionsMixedChart(
      {
        ...optionsMixedChart,
        xaxis: {
          type: "category",
          categories: props.data?.semanas
        }
      }
    );

  }, [props])

  return (
    <div id="chart001" className="mixed-chart">
      <Chart
        options={optionsMixedChart}
        series={seriesMixedChart}
        type="line"
        width={900}
        height={300}
      />
    </div>
  );
}

interface ChartProd01Props{
  data?: DashboardAcompProducaoDashJustificativa
}